<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card>
      <v-card-title>
        <h1>Create Palindrome String</h1>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs6>
            <v-textarea placeholder="Paste your text here" v-model="text"></v-textarea>
          </v-flex>
          <v-flex xs6>
            <v-textarea placeholder="Result" v-model="result"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" @click="create()">Create</v-btn>
          </v-flex>
          <actions :result="result" />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import v from 'voca'

export default {
  data: () => ({
    text: '',
    result: ''
  }),
  methods: {
    create() {
      this.result = this.text + v.reverse(this.text)
    }
  }
}
</script>

<style>
</style>